import axios from 'axios'
import { API_URL } from '../../../../../../constants'
import { DEPOSIT_CANCEL_REASON_API } from './consts'
import { DepositCancelReason, DepositCancelReasonRevision } from './response.types'
import { ReorderRequest, SaveDepositCancelReasonRequest } from './requests.types'

interface ApiResponse<T> {
  success: boolean
  data: T | null
  totalRows?: number
  errors?: Record<string, string>
  errorCode?: string
}

const BASE = `${API_URL}${DEPOSIT_CANCEL_REASON_API}`

export const getReasons = () =>
  axios.get<ApiResponse<DepositCancelReason[]>>(`${BASE}/list`, {
    params: { page: 1, perPage: 200 },
  })

export const getRevisions = (page: number, perPage: number) =>
  axios.get<ApiResponse<DepositCancelReasonRevision[]>>(`${BASE}/revisions`, {
    params: { page, perPage },
  })

export const createReason = (body: SaveDepositCancelReasonRequest) =>
  axios.post<ApiResponse<DepositCancelReason>>(BASE, body)

export const patchReason = (id: number, body: SaveDepositCancelReasonRequest) =>
  axios.patch<ApiResponse<DepositCancelReason>>(`${BASE}/${id}`, body)

export const reorderReasons = (ids: number[]) =>
  axios.patch<ApiResponse<DepositCancelReason[]>>(`${BASE}/reorder`, { ids } as ReorderRequest)
